import { render } from "./container-single.vue?vue&type=template&id=fe5a9cd4&scoped=true"
import script from "./container-single.vue?vue&type=script&lang=js"
export * from "./container-single.vue?vue&type=script&lang=js"

import "./container-single.vue?vue&type=style&index=0&id=fe5a9cd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5a9cd4"]])

export default __exports__